"use client";

import dynamic from "next/dynamic";
import { renderNothingIfChunkFails } from "@/lib/optional-chunk";

export const OddsHistoryModal = dynamic(
  () =>
    renderNothingIfChunkFails(
      import("@/components/odds/odds-history-modal").then((mod) => mod.OddsHistoryModal),
    ),
  { ssr: false },
);
